import api from './api';
import { Threshold, Alert, ThresholdTypeValue } from '../types';

export const thresholdService = {
  async getThresholds(sensorId?: number, createdById?: number): Promise<Threshold[]> {
    const params: { sensor_id?: number; created_by_id?: number } = {};
    if (sensorId !== undefined) params.sensor_id = sensorId;
    if (createdById !== undefined) params.created_by_id = createdById;
    const response = await api.get<Threshold[]>('/api/thresholds/', { params });
    return response.data;
  },

  async getThreshold(id: number): Promise<Threshold> {
    const response = await api.get<Threshold>(`/api/thresholds/${id}`);
    return response.data;
  },

  async createThreshold(data: {
    sensor_id: number;
    name: string;
    threshold_type: ThresholdTypeValue;
    condition: 'above' | 'below' | 'between';
    min_value?: number;
    max_value?: number;
  }): Promise<Threshold> {
    const response = await api.post<Threshold>('/api/thresholds/', data);
    return response.data;
  },

  async updateThreshold(id: number, data: Partial<Threshold>): Promise<Threshold> {
    const response = await api.put<Threshold>(`/api/thresholds/${id}`, data);
    return response.data;
  },

  async deleteThreshold(id: number): Promise<void> {
    await api.delete(`/api/thresholds/${id}`);
  },

  async getAlerts(sensorId?: number, resolved?: boolean): Promise<Alert[]> {
    const params: { sensor_id?: number; resolved?: boolean } = {};
    if (sensorId !== undefined) params.sensor_id = sensorId;
    if (resolved !== undefined) params.resolved = resolved;
    const response = await api.get<Alert[]>('/api/thresholds/alerts', { params });
    return response.data;
  },

  async resolveAlert(id: number): Promise<Alert> {
    const response = await api.put<Alert>(`/api/thresholds/alerts/${id}/resolve`);
    return response.data;
  },
};
